import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@klickdata/core/auth';
import { CustomerLanding } from '@klickdata/core/customer';
import { MobileService } from '@klickdata/core/mobile';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { Observable } from 'rxjs';
import { filter, shareReplay, takeUntil } from 'rxjs/operators';
import { GuestModeMobileLoginComponent } from './guest-mode-mobile-login/guest-mode-mobile-login.component';
import { GuestService } from '../guest.service';

@Component({
    selector: 'app-onboarding-guest-mode',
    templateUrl: './onboarding-guest-mode.component.html',
    styleUrls: ['./onboarding-guest-mode.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingGuestModeComponent extends OnDestroyHandler implements OnInit {
    public isMobile: boolean;
    public customerLanding$: Observable<CustomerLanding>;
    public openSearch: boolean;

    constructor(
        protected dialog: MatDialog,
        protected auth: AuthService,
        protected mobile: MobileService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected guestService: GuestService,
        protected bottomSheet: MatBottomSheet
    ) {
        super();
        this.mobile
            .isMobile()
            .pipe(shareReplay(), takeUntil(this.destroy))
            .subscribe((isMob) => (this.isMobile = isMob));
    }

    ngOnInit(): void {
        if (this.dialog.openDialogs.length > 0) {
            this.dialog.closeAll();
        }
        this.customerLanding$ = this.auth.getCustomerLanding();
    }

    onCancelSearch() {
        this.openSearch = false;
        this.router.navigate(['/guest/guest-landing']);
    }
    updateAccessMode(mode: 'login' | 'signup') {
        this.guestService.updateAccessMode(mode);
    }
    openLogin(customerLanding: CustomerLanding) {
        if (this.isMobile) {
            this.openMobile(customerLanding);
        } else {
            this.guestService.updateDrawer(true);
            this.guestService
                .afterDismissed()
                .pipe(
                    takeUntil(this.destroy),
                    filter((res) => !!res)
                )
                .subscribe(() => this.routeAfterLogin());
        }
    }
    public routeAfterLogin() {
        const uri = this.route.snapshot.queryParamMap.get('redirect_uri') || this.auth.homeUrl;
        this.router.navigateByUrl(uri);
    }
    openMobile(customerLanding: CustomerLanding) {
        this.bottomSheet
            .open(GuestModeMobileLoginComponent, {
                data: {
                    customerLanding: customerLanding,
                    accessMode: this.guestService.getAccessMode(),
                },
                panelClass: 'sheet-wrapper',
            })
            .afterDismissed()
            .pipe(
                filter((res) => !!res),
                takeUntil(this.destroy)
            )
            .subscribe(() => this.routeAfterLogin());
    }
}
